import angular from 'angular';
import socialAuth from './social-auth/social-auth.directive';
import mergeAccount from './merge-account/merge-account.directive';
import enterEmail from './enter-email/enter-email.directive';

export default angular
  .module('cian.social', [])
  .directive('cianAfSocialAuth', socialAuth)
  .directive('cianAfMergeAccount', mergeAccount)
  .directive('cianAfEnterEmail', enterEmail)
  .name;
